import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { HrisJobTitleList } from '../../../../entities/v1/HrisJobTitleList';

export interface ListParams {
  name?: string;
  page?: number;
  pageSize?: number;
}

export class HrisJobTitleService {
  public static list(params: ListParams) {
    return ApiService.get<HrisJobTitleList>(
      '/api/v1/applicant_tracking/hris_job_titles',
      snakecaseKeys(params),
    );
  }
}
